import UIIconButton from 'UIComponents/button/UIIconButton';
import styled, { css } from 'foundations-theming-specialty/utils';
const getSizeShortHand = size => {
  switch (size) {
    case 'extra-small':
      return 'xs';
    case 'small':
      return 'sm';
    case 'medium':
      return 'md';
    default:
      return size || 'md';
  }
};
const CssBaseIcon = css(["position:relative;display:block;border-radius:2rem !important;border:none !important;margin:", " !important;padding:", " !important;line-height:0 !important;& *{line-height:0 !important;}"], ({
  theme
}) => theme.space['0'], ({
  theme
}) => theme.space['0']);
export const getComputedFontSize = size => {
  const shorthandSize = getSizeShortHand(size);
  switch (shorthandSize) {
    case 'xs':
      return 24;
    case 'sm':
      return 32;
    case 'md':
      return 40;
    default:
      return 40;
  }
};
const getIconFontSize = size => {
  const sizePx = getComputedFontSize(size);
  if (size) {
    return css(["font-size:calc(", "px - 8px) !important;width:", "px !important;height:", "px !important;& > span{position:absolute;left:", ";top:", ";width:100%;height:100%;& > span{position:absolute;left:", ";top:50%;width:100%;height:100%;}}> span[data-icon-name='breezeRegenerate'] > span{top:calc(50% - ", ");font-size:calc(", "px - 7px) !important;}"], sizePx, sizePx, sizePx, ({
      theme
    }) => theme.space['0'], ({
      theme
    }) => theme.space['0'], ({
      theme
    }) => theme.space['0'], ({
      theme
    }) => theme.space['25'], sizePx);
  }
};
export const BreezeTransparentAIBaseIconButton = styled(UIIconButton).withConfig({
  displayName: "StyledAIBaseIconButton__BreezeTransparentAIBaseIconButton"
})(["", " ", " &:not(.disabled){color:", " !important;}&:hover{color:", " !important;}&:active{color:", " !important;}&&.disabled,&&[aria-disabled='true']{color:", " !important;}"], CssBaseIcon, ({
  size
}) => getIconFontSize(size), ({
  theme
}) => theme.color['icon-core-default'], ({
  theme
}) => theme.color['breeze-fill-primary-default'], ({
  theme
}) => theme.color['fill-accent-neutral-hover'], ({
  theme
}) => theme.color['icon-core-disabled']);
export const BreezeLinkOnDarkAIBaseIconButton = styled(UIIconButton).withConfig({
  displayName: "StyledAIBaseIconButton__BreezeLinkOnDarkAIBaseIconButton"
})(["", " ", " &:not(.disabled){color:", " !important;}&&.disabled{color:", " !important;}&:hover{color:", " !important;}&:active{color:", " !important;}"], CssBaseIcon, ({
  size
}) => getIconFontSize(size), ({
  theme
}) => theme.color['fill-surface-default'], ({
  theme
}) => theme.color['icon-core-disabled'], ({
  theme
}) => theme.color['breeze-fill-loading-dot-default'], ({
  theme
}) => theme.color['breeze-fill-secondary-hover']);
export const getStyledAIIconButton = use => {
  switch (use) {
    case 'transparent':
      return BreezeTransparentAIBaseIconButton;
    case 'link-on-dark':
      return BreezeLinkOnDarkAIBaseIconButton;
    default:
      return BreezeTransparentAIBaseIconButton;
  }
};